export class AdsClient {
    request;
    constructor(request) {
        this.request = request;
    }
    async promotables(kind = "menu_item", limit = 50) {
        return this.request("GET", `/v1/ads/promotables?kind=${encodeURIComponent(kind)}&limit=${limit}`, undefined, true);
    }
    preview(input) {
        return this.request("POST", "/v1/ads/previews", input, true);
    }
    createDraft(input) {
        return this.request("POST", "/v1/ads/campaigns", input, true);
    }
    async listCampaigns() {
        return this.request("GET", "/v1/ads/campaigns", undefined, true);
    }
    getCampaign(id) {
        return this.request("GET", `/v1/ads/campaigns/${encodeURIComponent(id)}`, undefined, true);
    }
    editCreative(campaignId, creativeId, copy) {
        return this.request("PATCH", `/v1/ads/campaigns/${encodeURIComponent(campaignId)}/creatives/${encodeURIComponent(creativeId)}`, copy, true);
    }
    approveCreative(campaignId, creativeId) {
        return this.request("POST", `/v1/ads/campaigns/${encodeURIComponent(campaignId)}/creatives/${encodeURIComponent(creativeId)}/approve`, undefined, true);
    }
    confirm(campaignId) {
        return this.lifecycle(campaignId, "confirm");
    }
    pause(campaignId) {
        return this.lifecycle(campaignId, "pause");
    }
    resume(campaignId) {
        return this.lifecycle(campaignId, "resume");
    }
    stop(campaignId) {
        return this.lifecycle(campaignId, "stop");
    }
    wallet() {
        return this.request("GET", "/v1/ads/wallet", undefined, true);
    }
    topUp(amountCents) {
        return this.request("POST", "/v1/ads/wallet/topups", { amountCents }, true);
    }
    report() {
        return this.request("GET", "/v1/ads/report", undefined, true);
    }
    lifecycle(id, action) {
        return this.request("POST", `/v1/ads/campaigns/${encodeURIComponent(id)}/${action}`, undefined, true);
    }
}
//# sourceMappingURL=ads.js.map